import { getResourceId } from "./getResourceId";
import { getResourcesNodes } from "./getResourcesNodes";

export function renameInteractiveZonesSvg(
  svg: SVGSVGElement,
  oldName: string,
  newName: string
) {
  const list = getResourcesNodes(svg);
  const node = (list || []).find((x) => getResourceId(x) === oldName);
  if (node) {
    node.id = newName;
    return true;
  }
  return false;
}
